import { Typography, Box, Container, Button, Paper, Chip } from '@mui/material';
import { ShoppingCart } from '@mui/icons-material';
import React from 'react';

type Props = {};

const RedrockOuthousePageLayout = (props: Props) => {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        gap: 4,
        mb: 4
      }}>
        {/* Book Image Section */}
        <Box sx={{ 
          flex: { xs: '1', md: '0 0 40%' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}>
          <Paper
            elevation={4}
            sx={{
              overflow: 'hidden',
              borderRadius: 2,
              maxWidth: '400px',
              width: '100%'
            }}
          >
            <img 
              src='/Redrock_Outhouse.jpg' 
              alt='Redrock Outhouse by Philip Payne'
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
          </Paper>
        </Box>

        {/* Book Details Section */}
        <Box sx={{ flex: 1 }}>
          <Typography 
            variant="h1" 
            sx={{ 
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              fontWeight: 700,
              color: '#2c3e50',
              mb: 1,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            }}
          >
            Redrock Outhouse
          </Typography>
          
          <Box sx={{ mb: 3 }}>
            <Chip 
              label="ASIN: B0FWM8PV8Q" 
              sx={{ 
                backgroundColor: '#ecf0f1',
                color: '#2c3e50',
                fontFamily: 'monospace',
                fontSize: '0.9rem'
              }} 
            />
          </Box>

          <Button
            variant="contained"
            startIcon={<ShoppingCart />}
            href="https://www.amazon.co.uk/Redrock-Outhouse-Philip-Payne-ebook/dp/B0FWM8PV8Q"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: '#e74c3c',
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              mb: 4,
              '&:hover': {
                backgroundColor: '#c0392b'
              },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Purchase on Amazon
          </Button>

          <Paper
            elevation={0}
            sx={{
              p: 3,
              backgroundColor: 'white',
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: '1.5rem', md: '1.75rem' },
                fontWeight: 600,
                color: '#2c3e50',
                mb: 2,
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
              }}
            >
              About the Book
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.9,
                color: '#444',
                fontFamily: 'Georgia, serif'
              }}
            >
              When an honest carpenter sets out to make an honest living, the privileged sons of the richest man in the county make things difficult for him. No longer prepared to look the other way for the crimes of others, Robert sets out on a quest to find justice, but soon realises that his actions are going to have consequences for himself and those dear to him.
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Container>
  );
};

export default RedrockOuthousePageLayout;
